import { render, staticRenderFns } from "./NPS.vue?vue&type=template&id=4c6555f0&scoped=true"
import script from "./NPS.vue?vue&type=script&lang=js"
export * from "./NPS.vue?vue&type=script&lang=js"
import style0 from "./NPS.vue?vue&type=style&index=0&id=4c6555f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6555f0",
  null
  
)

export default component.exports